import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Col, Form, Modal, Row, Spinner, Image } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import Dropdown from "../../../components/common/dropdowns/Dropdown";
import Input from "../../../components/common/Input";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import Button from "../../../components/common/Button";
import { SupportingDocsType } from "../redux/types/VerificationDetailsType";
import KYCListView from "../../../components/common/KYCDocsList";
import { uploadSupportingDoc } from "../redux/action/uploadSupportingDocAction";
import { updateSupportingStatus } from "../redux/action/updateSupportingStatus";
import { getSessionId, getUserRole } from "../../../utils/tokenHandlers";
import axios from "axios";
import { deleteDocument } from "../../guestUser/ppApplication/redux/action/deleteDocument";
import { useParams } from "react-router-dom";
import { getAppAction } from "../../opsUser/ppApplication/ppIndia/redux/action/getAppAction";
import { DisplayBox } from "../../../components/containers/DisplayBox";
import AlertPopup from "../../../components/common/Alert/AlertPopup";
import { getVerStatusKeyPerson } from "../redux/action/getVerStatusKeyPerson";
import handleFileWithSizeLimit from "../../constants/fileSizeLimit";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

interface verSupportingDocProps {
  docId: number;
  docType: string;
}

const VerSupportingDocKeyPerson: React.FC<verSupportingDocProps> = ({
  docId,
  docType,
}) => {
  const {
    register,
    handleSubmit,
    // watch,
    formState: { errors },
  } = useForm<SupportingDocsType>({
    shouldUnregister: true,
  });

  const dispatch = useDispatch<AppDispatch>();
  const [showSaveSpinner, setShowSaveSpinner] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [docName, setDocName] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [attachmentids, setAttachmentids] = useState<string | null>(null);
  const [showUploadSpinner, setShowUploadSpinner] = useState(false);
  const [showModalSpinner, setShowModalSpinner] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const [showUploadSuccess, setShowUploadSuccess] = useState(false);
  const [showDataUpdateSuccess, setShowDataUpdateSuccess] = useState(false);
  const sessionId = getSessionId();
  const [imageData, setImageData] = useState("");
  const [fileType, setFileType] = useState("");
  const { appId } = useParams();
  const customerId = Number(appId);
  useEffect(() => {
    dispatch(getAppAction(customerId));
  }, [dispatch, customerId]);
  const state1 = useSelector((state: RootState) => state.opsPpIndApp.getApp);
  const appStage = state1.data.stage;
  const userRole = getUserRole();
  const state = useSelector(
    (state: RootState) => state.verification.verStatusKeyPerson
  );
  const keyPersonId = state.data.data.result.result[0].customer_key_person_id;
  if (!state.data || !state.data.data) {
    return null;
  }

  const handleImage = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;

    if (selectedFiles && selectedFiles.length > 0) {
      const selectedFile = selectedFiles[0];

      // const selectedFile = event.target.files?.[0] || null;
      setSelectedFile(selectedFile);
      if (selectedFile) {
        setDocName(selectedFile.name);
      }

      // Check if the file type is allowed
      const allowedTypes = ["pdf", "jpeg", "png", "jpg"];
      const fileType = selectedFile.name.split(".").pop()?.toLowerCase();

      if (!fileType || !allowedTypes.includes(fileType)) {
        // Display an alert or take appropriate action
        alert(
          "Unsupported file type. Please select a file with one of the following types: pdf, jpeg, png, jpg"
        );
        setSelectedFile(null);
        setDocName(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
          // setMaUploadSpinner(false);
        }
        return;
      }

      // setImage(selectedFile);
      // localStorage.setItem("fileName", selectedFile.name);
      // setDocName(selectedFile.name);
      // setUploadDisabled(false);
      // setButtonText("Upload");
    } else {
      // console.warn("No files selected.");
    }
  };

  const statusRemarksStore = state.data.data.result.result[0];
  const handleAPI = async () => {
    setShowUploadSuccess(false);
    localStorage.removeItem("attachmentids");
    if (!selectedFile) {
      alert("Please select a file before uploading.");
      return;
    }

    // console.log("Selected File:", selectedFile.name);
    // console.log("File properties:", selectedFile);

    if (docName && selectedFile) {
      setShowUploadSpinner(true);

      // console.warn("done");
      try {
        const response = await dispatch(
          uploadSupportingDoc({ docName, selectedFile })
        );
        if (response.payload.message === "Success") {
          // console.log("in main file-->", response.payload);
          const attachmentids = localStorage.getItem("attachmentids");
          setAttachmentids(attachmentids);
          setShowUploadSpinner(false);
          // alert("Document Uploaded!");
          const data = {
            maker_verification_attachment_ids:
              attachmentids !== null ? [parseInt(attachmentids, 10)] : [],
          };
          let selectedId = keyPersonId;
          let selectedDocId = docId;
          dispatch(updateSupportingStatus({ docId, data })).then((res) => {
            dispatch(getVerStatusKeyPerson({ selectedId, selectedDocId })).then(
              (resp) => {
                setShowUploadSuccess(true);
              }
            );
          });

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
            // setButtonText("Upload");
          }
        }
      } catch (error) {
        setShowUploadSpinner(false);

        // console.error("An error occurred", error);
      }
    } else {
      setShowUploadSpinner(false);

      // console.warn("Something went wrong");
    }
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] || null;
    setSelectedFile(selectedFile);
    if (selectedFile) {
      setDocName(selectedFile.name);
    }
  };

  const handleSupportingDocStatus: SubmitHandler<SupportingDocsType> = async (
    formData
  ) => {
    setShowDataUpdateSuccess(false);
    const data = {
      ...formData,
      // maker_verification_attachment_ids:
      //   attachmentids !== null ? [parseInt(attachmentids, 10)] : [],
    };
    // console.warn("data =", data);
    try {
      setShowSaveSpinner(true);
      const result = await dispatch(updateSupportingStatus({ docId, data }));
      if (result.payload) {
        // console.log("in main file", result.payload);
        setShowSaveSpinner(false);
        // alert("Data Updated!");
        let selectedDocId = docId;
        let selectedId = keyPersonId;
        dispatch(getVerStatusKeyPerson({ selectedId, selectedDocId }));
        setShowDataUpdateSuccess(true);
        // window.location.reload();
      }
    } catch (error) {
      setShowSaveSpinner(false);
      // console.error("An error occured", error);
    }
  };

  const handleDocumentClick = async () => {
    setShowUpload(true);
  };

  const handleDocumentDelete = async () => {
    // const docId = statusRemarksStore.maker_verification_attachment_ids[0];
    // if (docId) {
    //   try {
    //     const result = await dispatch(deleteDocument(docId));
    //     if (result.payload) {
    //       // console.warn(result.payload);
    //       // console.log("docid--", docId);
    //       window.location.reload();
    //       // console.warn("Document deleted");
    //     } else {
    //       // console.warn("error");
    //     }
    //   } catch (error) {
    //     // console.warn("Something went wrong", error);
    //   }
    // } else {
    //   // console.warn("else block");
    // }
    const data = {
      maker_verification_attachment_ids: [],
    };
    let selectedId = keyPersonId;
    let selectedDocId = docId;
    dispatch(updateSupportingStatus({ docId, data })).then((res) => {
      dispatch(getVerStatusKeyPerson({ selectedId, selectedDocId })).then(
        (resp) => {
          // setShowUploadSuccess(true);
        }
      );
    });
  };

  // view supporting document
  const handleDocumentView = async () => {
    const docId = statusRemarksStore.maker_verification_attachment_ids[0];

    if (docId) {
      handleShow();
      const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;
      const headers = {
        Authorization: `Bearer ${sessionId}`,
      };
      try {
        setShowModalSpinner(true);
        const response = await axios.post(
          apiUrl,
          { params: { ...UidEmailRoleMatch() } },
          { headers }
        );

        const fileString: string = response.data.result;

        if (fileString.startsWith("%PDF")) {
          // Convert string → binary array (safe for older TS targets)
          const byteArray = new Uint8Array(fileString.length);
          for (let i = 0; i < fileString.length; i++) {
            byteArray[i] = fileString.charCodeAt(i);
          }

          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          setImageData(blobUrl);
          setFileType("pdf");
        } else {
          const base64Data = btoa(fileString);
          const imageBase64 = `data:image/png;base64,${base64Data}`;
          setImageData(imageBase64);
          setFileType("img");
        }

        setShowModalSpinner(false);
      } catch (error) {
        // console.error("Error fetching file:", error);
        setShowModalSpinner(false);
      }
    } else {
      alert("Document is not uploaded!");
    }
  };

  return (
    <>
      {/* <p>{keyPersonId}</p> */}
      <Row>
        <DisplayBox display={showUploadSuccess}>
          <AlertPopup variant="success" message="Document Uploaded!" />
        </DisplayBox>
        <DisplayBox display={showDataUpdateSuccess}>
          <AlertPopup variant="success" message="Data Updated!" />
        </DisplayBox>
        <Row className="m-2">
          <KYCListView
            items={[
              {
                label: "Supporting Document",
                required: false,
                onCancelClick: () => {
                  if (
                    appStage == "In Maker Verification" &&
                    userRole == "maker"
                  ) {
                    handleDocumentDelete();
                  } else {
                    alert("Cannot delete the document");
                  }
                },
                onViewClick: () => {
                  // handleShow();
                  handleDocumentView();
                },
                onClick: () => {
                  if (
                    userRole == "maker" &&
                    appStage === "In Maker Verification"
                  ) {
                    handleDocumentClick();
                  }
                },
                style: {
                  backgroundColor:
                    statusRemarksStore.maker_verification_attachment_ids
                      .length !== 0
                      ? "#9ef89e"
                      : "",
                },
              },
            ]}
          />
        </Row>
        <Row className="m-2">
          {showUpload ? (
            <>
              {/* <Form.Control id="fileInput" type="file" /> */}
              <Row>
                <Form.Control
                  id="fileInput"
                  type="file"
                  // onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <Form.Group controlId="formFileMultiple" className="mb-3">
                  <Form.Control
                    type="file"
                    multiple
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      handleFileWithSizeLimit(e, undefined, handleImage)
                    }
                    ref={fileInputRef}
                    accept=".pdf, .jpeg, .png, .jpg"
                  />
                </Form.Group>
              </Row>
              <Row className="text-center">
                <Col md={12}>
                  {showUploadSpinner ? (
                    <Spinner
                      animation="border"
                      role="status"
                      variant="primary"
                    ></Spinner>
                  ) : (
                    <Button
                      label="Upload"
                      type="button"
                      onClick={handleAPI}
                      // disabled={uploadDisabled}
                      disabled={
                        appStage === "Expired" ||
                        appStage === "Customer Registered" ||
                        appStage === "In Customer Registration" ||
                        (appStage == "In Checker Verification" &&
                          userRole == "maker")
                      }
                    />
                  )}
                </Col>
              </Row>
            </>
          ) : null}
          <Form>
            <Row md={12}>
              <Dropdown
                label="Supporting Document Status"
                name="maker_verification_attachment_status"
                defaultValue={
                  statusRemarksStore.maker_verification_attachment_status
                }
                register={register}
                // disabled
                // required
                // error={errors.maker_verification_attachment_status?.message}
                // requiredMessage="API verification status is required"
                options={[
                  { label: "Success", value: "Success" },
                  { label: "Failure", value: "Failure" },
                ]}
              />
            </Row>
            <Row>
              <Input
                label="Supporting Document Remarks"
                name="maker_verification_attachment_comments"
                register={register}
                // required
                defaultValue={
                  statusRemarksStore.maker_verification_attachment_comments
                }
                // disabled
                // error={errors.maker_verification_attachment_comments?.message}
                // requiredMessage="API verification remarks is required"
              />
            </Row>
            <Row>
              {(appStage == "In Maker Verification" ||
                appStage == "In Checker Verification") && (
                <Col className="text-end">
                  {showSaveSpinner ? (
                    <Spinner animation="border" variant="primary" />
                  ) : (
                    <Button
                      type="submit"
                      label="Save Details"
                      onClick={handleSubmit(handleSupportingDocStatus)}
                      disabled={
                        appStage === "Expired" ||
                        appStage === "Customer Registered" ||
                        appStage === "In Customer Registration" ||
                        (appStage == "In Checker Verification" &&
                          userRole == "maker") ||
                        (appStage == "In Maker Verification" &&
                          userRole == "checker")
                      }
                    />
                  )}
                </Col>
              )}
            </Row>
          </Form>
        </Row>
      </Row>
      <Modal show={show} onHide={handleClose} keyboard={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Document View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="text-center">
              {showModalSpinner ? (
                <Spinner variant="primary" animation="border" />
              ) : //
              fileType === "pdf" ? (
                <iframe
                  src={imageData}
                  title="Document viewer"
                  style={{ width: "400px", height: "300px" }}
                />
              ) : (
                <Image
                  src={imageData}
                  style={{ width: "600px", height: "400px" }}
                />
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VerSupportingDocKeyPerson;
